import type { QuizsetSearchReq } from '@/api/gen/_model/quizsetSearchReq';
import {
  _delete,
  create,
  get,
  listMine,
  searchMine,
} from '@/api/gen/quizset-folder-controller/quizset-folder-controller.gen';

import type { Collection, CollectionSummary } from '../../types';
import { toCollection, toCollectionFromSearch } from '../collection.adapters';

export interface CollectionCursorPage {
  items: Collection[];
  nextCursor?: string;
}

export interface CollectionSearchPage {
  items: CollectionSummary[];
  currentPage: number;
  totalPages: number;
  totalCount: number;
}

export const fetchMyCollections = async (
  cursor?: string,
): Promise<CollectionCursorPage> => {
  const res = await listMine({ cursor });
  return {
    items: res.data.items.map(toCollection),
    nextCursor: res.data.nextCursor,
  };
};

export const searchMyCollections = async (
  body: QuizsetSearchReq,
): Promise<CollectionSearchPage> => {
  const res = await searchMine(body);
  return {
    items: (res.data ?? []).map(toCollectionFromSearch),
    currentPage: res.currentPage,
    totalPages: res.totalPages,
    totalCount: res.totalCount,
  };
};

export const fetchCollectionDetail = async (id: string): Promise<Collection> =>
  toCollection((await get(id)).data);

export const createCollection = async (name: string): Promise<Collection> =>
  toCollection((await create({ name })).data);

export const deleteCollection = async (id: string): Promise<void> => {
  await _delete(id);
};
